import { render, staticRenderFns } from "./MetricCard.vue?vue&type=template&id=052851f4&scoped=true&"
import script from "./MetricCard.vue?vue&type=script&lang=js&"
export * from "./MetricCard.vue?vue&type=script&lang=js&"
import style0 from "./MetricCard.vue?vue&type=style&index=0&id=052851f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052851f4",
  null
  
)

export default component.exports